import Language from '../Language'

export default new Language(
  'English',
  ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  ['S', 'M', 'T', 'W', 'T', 'F', 'S']
)
// eslint-disable-next-line
;
